module.exports = __webpack_public_path__ + "static/img/index.f8a1eae.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/wechat/index.png
// module id = /WE9
// module chunks = 1